import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { Dispatch } from 'redux';
import { RootState } from '../../../../@types/RootState';
import { StoreType } from '../../../../pages/IPA/Estrategia/pages/RegrasDePreco/lib/data';

export type StoreTypeWithoutAllStores = Exclude<StoreType, 'all-stores'>;

type StoreItemProps = {
  query: Record<StoreTypeWithoutAllStores, string>;
  value: Record<StoreTypeWithoutAllStores, string[]>;
  data: Record<StoreTypeWithoutAllStores, DataItem[]>;
  cache: Record<StoreTypeWithoutAllStores, DataItem[]>;
};

type RegisterLimitStoreStore = {
  selectType: StoreType;
  data: StoreItemProps;
};

const initialStoreData: StoreItemProps = {
  query: {
    'individual-store': '',
    clusters: '',
  },
  value: {
    'individual-store': [],
    clusters: [],
  },
  data: {
    'individual-store': [],
    clusters: [],
  },
  cache: {
    'individual-store': [],
    clusters: [],
  },
};

const initialState: RegisterLimitStoreStore = {
  selectType: 'all-stores',
  data: initialStoreData,
};

const slice = createSlice({
  name: 'ipa/limits/store',
  initialState,
  reducers: {
    setSelectType: (state, action: PayloadAction<StoreType>) => {
      state.selectType = action.payload;
    },
    setStoreDataByKey: (state, action: PayloadAction<{ key: StoreTypeWithoutAllStores; value: DataItem[] }>) => {
      state.data.data[action.payload.key] = action.payload.value;
    },
    setStoreCacheByKey: (state, action: PayloadAction<{ key: StoreTypeWithoutAllStores; value: DataItem[] }>) => {
      state.data.cache[action.payload.key] = action.payload.value;
    },
    resetStore: state => {
      state.data = initialStoreData;
    },
    setStoreQueryByKey: (state, action: PayloadAction<{ key: StoreTypeWithoutAllStores; value: string }>) => {
      state.data.query[action.payload.key] = action.payload.value;
    },
    setStoreValueByKey: (state, action: PayloadAction<{ key: StoreTypeWithoutAllStores; value: string[] }>) => {
      state.data.value[action.payload.key] = action.payload.value;
    },
    addStoreDataByKey: (state, action: PayloadAction<{ key: StoreTypeWithoutAllStores; value: DataItem[] }>) => {
      state.data.data[action.payload.key] = _.uniqBy([...state.data.data[action.payload.key], ...action.payload.value], 'value');
    },
  },
});

export default slice.reducer;

export const { setSelectType, setStoreDataByKey, setStoreCacheByKey, addStoreDataByKey, resetStore, setStoreQueryByKey, setStoreValueByKey } = slice.actions;

export const selector = (state: RootState) => state.ipa.limits.filters.store;

export const mapStateToProps = (store: RootState) => ({
  selectType: store.ipa.limits.filters.store.selectType,
  data: store.ipa.limits.filters.store.data,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  resetStore: () => {
    dispatch(resetStore());
  },
  resetStoreQueryByKey: (key: StoreTypeWithoutAllStores) => {
    dispatch(setStoreQueryByKey({ key, value: '' }));
  },
  resetStoreValueByKey: (key: StoreTypeWithoutAllStores) => {
    dispatch(setStoreValueByKey({ key, value: [] }));
  },
  resetStoreCacheByKey: (key: StoreTypeWithoutAllStores) => {
    dispatch(setStoreCacheByKey({ key, value: [] }));
  },
  setSelectType: (value: StoreType) => {
    dispatch(setSelectType(value));
  },
  setStoreQueryByKey: (key: StoreTypeWithoutAllStores, value: string) => {
    dispatch(setStoreQueryByKey({ key, value }));
  },
  setStoreValueByKey: (key: StoreTypeWithoutAllStores, value: string[]) => {
    dispatch(setStoreValueByKey({ key, value }));
  },
  setStoreDataByKey: (key: StoreTypeWithoutAllStores, value: DataItem[]) => {
    dispatch(setStoreDataByKey({ key, value }));
  },
  addStoreDataByKey: (key: StoreTypeWithoutAllStores, value: DataItem[]) => {
    dispatch(addStoreDataByKey({ key, value }));
  },
  setStoreCacheByKey: (key: StoreTypeWithoutAllStores, value: DataItem[]) => {
    dispatch(setStoreCacheByKey({ key, value }));
  },
});
